export const CARD_RADIUS = {
  sm: 8,
  md: 12,
  lg: 16,
} as const;

export const CARD_SHADOW = {
  none: 'none',
  sm: '0px 2px 10px rgba(0, 0, 0, 0.05)',
  md: '0px 2px 10px rgba(0, 0, 0, 0.10)',
  lg: '0px 4px 10px rgba(0, 0, 0, 0.15)',
} as const;

export const CARD_PADDING = {
  compact: 1.5, // 12px in MUI spacing
  default: 2,   // 16px
  spacious: 3,  // 24px
} as const;

/** Standard left accent bar width */
export const ACCENT_BAR_WIDTH = 6;
